import React, { Suspense, lazy } from 'react';
import { IntroCurtain } from './components/ui/IntroCurtain';
import { LanguageProvider } from './i18n/LanguageContext';
// Lazy-load EVERYTHING else so the initial JS bundle only contains
// IntroCurtain. This dramatically reduces the time-to-first-paint on mobile.
const SiteContent = lazy(() => import('./SiteContent').then(m => ({
  default: m.SiteContent
})));
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-riam-black text-riam-gold selection:bg-riam-gold selection:text-riam-black" data-id="element-1">
        <IntroCurtain data-id="element-2" />
        <Suspense fallback={<div className="min-h-screen bg-riam-black" data-id="element-4" />} data-id="element-3">
          <SiteContent data-id="element-5" />
        </Suspense>
      </div>
    </LanguageProvider>;
}